import CourseCard from './CourseCard.vue';
import CardHeader from '@/pages/components/CardHeader';
import { Empty } from 'zhs-components';
import { ArrowDown } from '@element-plus/icons-vue';
export default {
  components: {
    CourseCard,
    Empty,
    CardHeader
  },
  props: {
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number,
      default: 0
    }
  },

  created() {
    this.getAuth();
    this.getTypeList();
  },

  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList();
      },

      immediate: true
    }
  },

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: ''
    };
  },

  methods: {
    // 分类展开折叠
    handleToggleExpand() {
      this.hiddenMoreClass = !this.hiddenMoreClass;
    },

    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId
      });
      this.homeCourseList = homeCourse;
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == '10401') ? res2.find(item => item.code == '10401').auth_type : 0;
    },

    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      });
      this.typeList = res; // if (res && res.length) {
      //   this.typeId = res[0].id
      // }
    },

    searchCourseList(id) {
      this.typeId = id;
    }

  }
};